"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowNumericEditor_1 = require("../../../../../../shared/components/editors/CardRowNumericEditor");
var CardRowDateEdit_1 = require("../../../../../../shared/components/editors/CardRowDateEdit");
var CardRowTimeEdit_1 = require("../../../../../../shared/components/editors/CardRowTimeEdit");
var WinnerTopEditor = /** @class */ (function (_super) {
    __extends(WinnerTopEditor, _super);
    function WinnerTopEditor(props) {
        return _super.call(this, props) || this;
    }
    WinnerTopEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    winner_top_tag: _item.winner_top_tag,
                    usr_player_login: _item.usr_player_login,
                    is_locked: _item.is_locked,
                    brand_id: _item.brand_id,
                    brand_title: _item.brand_title,
                    usr_player_id: _item.usr_player_id,
                    win_amount: _item.win_amount,
                    brand_usr_players_avail: [],
                    win_year: _item.win_year,
                    win_month: _item.win_month,
                    win_day: _item.win_day,
                    win_hour: _item.win_hour,
                    win_minute: _item.win_minute,
                    win_second: _item.win_second,
                    gws_gameprovider_id: _item.gws_gameprovider_id,
                    gws_gameprovider_title: _item.gws_gameprovider_title,
                    gws_gameprovider_game_id: _item.gws_gameprovider_game_id,
                    gws_gameprovider_game_title: _item.gws_gameprovider_game_title,
                    gws_gameproviders_avail: [],
                    gws_gameprovider_games_avail: []
                }, function () {
                    _this.props.dataUsrPlayers.LoadData(_this.props.record.brand_id);
                    _this.props.state.setExtBreadCrumbPath(["Редактирование победителя"]);
                });
            }
        }
        else {
            this.setState({
                winner_top_tag: "",
                usr_player_id: 0,
                is_locked: false,
                brand_id: 0,
                brand_title: "",
                usr_player_login: "",
                win_amount: 10000,
                brand_usr_players_avail: [],
                win_year: 1990,
                win_month: 1,
                win_day: 1,
                win_hour: 0,
                win_minute: 0,
                win_second: 0,
                gws_gameprovider_id: 0,
                gws_gameprovider_title: "",
                gws_gameprovider_game_id: 0,
                gws_gameprovider_game_title: "",
                gws_gameproviders_avail: [],
                gws_gameprovider_games_avail: []
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание победителя"]);
            });
        }
        this.SID_AU = this.props.dataUsrPlayers.Subscribe("*", function (id, data) {
            _this.setState({ brand_usr_players_avail: data.data });
        });
        this.SID_AGGP = this.props.dataGwsGameProviders.Subscribe("*", function (id, data) {
            _this.setState({ gws_gameproviders_avail: data.data });
        });
        this.SID_AGGP_GAMES = this.props.dataGwsGameProviderGames.Subscribe("*", function (id, data) {
            _this.setState({ gws_gameprovider_games_avail: data.data });
        });
        this.props.dataGwsGameProviders.LoadData();
        this.doReSetRules();
    };
    WinnerTopEditor.prototype.componentWillUnmount = function () {
        this.props.dataUsrPlayers.UnSubscribe(this.SID_AU);
        this.props.dataGwsGameProviders.UnSubscribe(this.SID_AGGP);
        this.props.dataGwsGameProviderGames.UnSubscribe(this.SID_AGGP_GAMES);
    };
    WinnerTopEditor.prototype.doReSetRules = function () {
        this.setState({
            brand_rules: { isError: false },
            usr_player_rules: { isError: false },
            win_amount_rules: { isError: false },
            gws_gameprovider_rules: { isError: false },
            gws_gameprovider_game_rules: { isError: false }
        });
    };
    WinnerTopEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.brand_id <= 0) || (this.state.brand_title.length === 0)) {
            this.setState({ brand_rules: { isError: true, errorMessage: "Поле [бренд] не выбрано!" } });
            return false;
        }
        if ((this.state.usr_player_id <= 0) || (this.state.usr_player_login.length === 0)) {
            this.setState({ usr_player_rules: { isError: true, errorMessage: "Поле [игрок] не выбрано!" } });
            return false;
        }
        if ((this.state.gws_gameprovider_id <= 0) || (this.state.gws_gameprovider_title.length === 0)) {
            this.setState({ gws_gameprovider_rules: { isError: true, errorMessage: "Поле [геймпровайдер] не выбрано!" } });
            return false;
        }
        if ((this.state.gws_gameprovider_game_id <= 0) || (this.state.gws_gameprovider_game_title.length === 0)) {
            this.setState({ gws_gameprovider_game_rules: { isError: true, errorMessage: "Поле [игра] не выбрано!" } });
            return false;
        }
        if ((this.state.win_amount <= 0) || (this.state.win_amount >= 999999)) {
            this.setState({ win_amount_rules: { isError: true, errorMessage: "Поле [выигрыш] заполнено некорректно!" } });
            return false;
        }
        return true;
    };
    WinnerTopEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                usr_player_id: this.state.usr_player_id,
                win_amount: this.state.win_amount,
                is_locked: this.state.is_locked,
                winner_top_tag: this.state.winner_top_tag,
                win_year: this.state.win_year,
                win_month: this.state.win_month,
                win_day: this.state.win_day,
                win_hour: this.state.win_hour,
                win_minute: this.state.win_minute,
                win_second: this.state.win_second,
                gws_gameprovider_game_id: this.state.gws_gameprovider_game_id,
                gws_gameprovider_id: this.state.gws_gameprovider_id
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Победитель изменен!");
            });
        }
    };
    WinnerTopEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                usr_player_id: this.state.usr_player_id,
                win_amount: this.state.win_amount,
                brand_id: this.state.brand_id,
                is_locked: this.state.is_locked,
                winner_top_tag: this.state.winner_top_tag,
                win_year: this.state.win_year,
                win_month: this.state.win_month,
                win_day: this.state.win_day,
                win_hour: this.state.win_hour,
                win_minute: this.state.win_minute,
                win_second: this.state.win_second,
                gws_gameprovider_id: this.state.gws_gameprovider_id,
                gws_gameprovider_game_id: this.state.gws_gameprovider_game_id
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Победитель добавлен!");
            });
        }
    };
    WinnerTopEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    WinnerTopEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить победителя";
        }
        else {
            return "Изменить победителя";
        }
    };
    WinnerTopEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 640 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Тэг победителя:", placeholder: "Введите тэг победителя" }, value: this.state.winner_top_tag, onValueChanged: function (newVal) { _this.setState({ winner_top_tag: newVal }); } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Бренд:", placeholder: "Выберите бренд" }, value: {
                    key: this.state.brand_id,
                    value: this.state.brand_title
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_id: newVal.key,
                        brand_title: newVal.value,
                        brand_rules: { isError: false },
                        brand_usr_players_avail: [],
                        usr_player_id: 0,
                        usr_player_login: ""
                    }, function () {
                        _this.props.dataUsrPlayers.LoadData(_this.state.brand_id);
                    });
                }, items: this.props.brandsAvail, disabled: this.props.record != null, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Игрок:", placeholder: "Выберите игрока" }, value: {
                    key: this.state.usr_player_id,
                    value: this.state.usr_player_login
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        usr_player_id: newVal.key,
                        usr_player_login: newVal.value,
                        usr_player_rules: { isError: false }
                    });
                }, items: this.state.brand_usr_players_avail, required: true, rules: this.state.usr_player_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Геймпровайдер:", placeholder: "Выберите геймпровайдер" }, value: {
                    key: this.state.gws_gameprovider_id,
                    value: this.state.gws_gameprovider_title
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        gws_gameprovider_id: newVal.key,
                        gws_gameprovider_title: newVal.value,
                        gws_gameprovider_rules: { isError: false },
                        gws_gameprovider_games_avail: [],
                        gws_gameprovider_game_id: 0,
                        gws_gameprovider_game_title: ""
                    }, function () {
                        _this.props.dataGwsGameProviderGames.LoadData(_this.state.gws_gameprovider_id);
                    });
                }, items: this.state.gws_gameproviders_avail, required: true, rules: this.state.gws_gameprovider_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Игра:", placeholder: "Выберите игру" }, value: {
                    key: this.state.gws_gameprovider_game_id,
                    value: this.state.gws_gameprovider_game_title
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        gws_gameprovider_game_id: newVal.key,
                        gws_gameprovider_game_title: newVal.value,
                        gws_gameprovider_game_rules: { isError: false }
                    });
                }, items: this.state.gws_gameprovider_games_avail, required: true, rules: this.state.gws_gameprovider_game_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Выигрыш:", placeholder: "Введите выигрыш" }, values: {
                    max: 999999,
                    min: 10,
                    value: this.state.win_amount
                }, onValueChanged: function (newVal) {
                    _this.setState({ win_amount: newVal, win_amount_rules: { isError: false } });
                }, required: true, rules: this.state.win_amount_rules }),
            React.createElement(CardRowDateEdit_1.default, { texts: { caption: "Дата победы", placeholder: "Выберите дату" }, value: {
                    day: this.state.win_day,
                    month: this.state.win_month,
                    year: this.state.win_year
                }, onValueChanged: function (year, month, day) {
                    _this.setState({ win_day: day, win_month: month, win_year: year });
                } }),
            React.createElement(CardRowTimeEdit_1.default, { texts: { caption: "Время победы", placeholder: "Выберите время" }, value: {
                    hour: this.state.win_hour,
                    minute: this.state.win_minute,
                    second: this.state.win_second
                }, onValueChanged: function (hour, minute, second) {
                    _this.setState({
                        win_hour: hour,
                        win_minute: minute,
                        win_second: second
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Бот заблокирован", value: this.state.is_locked, onChecked: function (checked) {
                    _this.setState({ is_locked: checked });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return WinnerTopEditor;
}(React.Component));
exports.default = WinnerTopEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_winners_top/ui/component/WinnersTopEditor.tsx
// module id = 2338
// module chunks = 0